"use client";
import RightDrawer from "@/components/ui/drawer/RightDrawer";
import Form from "@/components/ui/forms/tailwind/Form";
import { Comment } from "@prisma/client";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { TfiCommentAlt } from "react-icons/tfi";
import { addComment } from "./addComment";
import { getComments } from "./getComments";
import ShowComment from "./ShowComment";
import { updateResolved } from "./updateResolved";
type props = {
  groupId: string | null;
  userId: string;
  subject: string;
  subjectId: string;
  style?: "bubble" | "triangle";
};
const Comments = ({
  groupId,
  subject,
  subjectId,
  userId,
  style = "bubble",
}: props) => {
  const [open, setOpen] = useState(false);
  const [comments, setComments] = useState<Comment[]>([]);

  useEffect(() => {
    getComments({ groupId, subject, subjectId }).then(setComments);
  }, [groupId, subject, subjectId]);

  const form = useForm({
    defaultValues: {
      groupId,
      subject,
      subjectId,
      body: "",
    },
  });

  const handleSubmit = (data: any) => {
    addComment(data).then((data) => {
      form.reset();
      getComments({ groupId, subject, subjectId }).then(setComments);
    });
  };

  const handleResolve = ({
    commentId,
    isResolved,
  }: {
    commentId: string;
    isResolved: boolean;
  }) => {
    updateResolved({ commentId, isResolved }).then((r) =>
      getComments({ groupId, subject, subjectId }).then(setComments)
    );
  };

  return (
    <>
      {style === "bubble" ? (
        <button onClick={() => setOpen(true)} className="relative">
          <TfiCommentAlt className="h-5 w-auto" />
          {comments.some((c) => c.isResolved === false) && (
            <>
              <div className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-red-500" />
              <div className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-red-500 animate-ping" />
            </>
          )}
        </button>
      ) : (
        <button onClick={() => setOpen(true)} className="absolute">
          <div
            className={classNames(
              "h-5 w-auto bg-red-500",
              comments.length > 0 ? "opacity-100" : "opacity-50"
            )}
          />
          {comments.some((c) => c.isResolved === false) && (
            <>
              <div className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-red-500" />
              <div className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-red-500 animate-ping" />
            </>
          )}
        </button>
      )}

      <RightDrawer open={open} setOpen={setOpen}>
        <div className="flex h-full flex-col">
          <div className="flex-1 overflow-y-auto">
            <div className="divide-y">
              {comments
                .filter((c) => c.isResolved === false)
                .map((comment) => (
                  <ShowComment
                    data={comment}
                    key={comment.id}
                    userId={userId}
                    handleResolve={handleResolve}
                  />
                ))}
            </div>
            {comments.some((c) => c.isResolved) && (
              <div>
                <h3 className="mb-2 mt-6 font-bold">Resueltos</h3>
                <div className="divide-y text-gray-400">
                  {comments
                    .filter((c) => c.isResolved === true)
                    .map((comment) => (
                      <ShowComment
                        data={comment}
                        key={comment.id}
                        userId={userId}
                        handleResolve={handleResolve}
                      />
                    ))}
                </div>
              </div>
            )}
          </div>

          <div className="mt-4">
            <Form onSubmit={handleSubmit} methods={form}>
              <div className="h-18 ">
                <textarea
                  placeholder="escribe tu comentario ..."
                  {...form.register("body")}
                  className="h-full w-full rounded-md border-none bg-slate-100 p-2"
                />
              </div>
              <div className="mt-4 text-right">
                <button className="rounded-md bg-wosm-default px-4  py-1 font-semibold text-white shadow-sm hover:bg-wosm-dark">
                  Enviar
                </button>
              </div>
            </Form>
          </div>
        </div>
      </RightDrawer>
    </>
  );
};

export default Comments;
